import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const businessUnits = [{
  title: "High-Precision Optical Fiber",
  description: "Advanced G652D and G657A1/A2 fibers engineered for AI data centers and global telecom networks. Featuring ultra-low attenuation and superior macro-bending performance for mission-critical connectivity and high-speed data transmission.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/fiber_pillar.png",
  link: "/ProductsPage"
}, {
  title: "FPV DRONE PARTS\xA0\xA0",
  description: "Cutting-edge drone ecosystems featuring carbon fiber frames, high-KV motors, and AI-integrated flight controllers. Designed for extreme agility, precision control, and industrial-grade reliability in the most demanding flight environments. Provide FPV drone frame, flight controller, video transmission,\xA0 camera, mushroom antenna, propeller, dual receiver, battery module etc components.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604101/img/drone_pillar.png",
  link: "/ProductsPage"
}];
export default function BusinessUnits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="10729" id="core-technology-pillars" ref={ref} className="w-full dark bg-background text-foreground overflow-hidden">
      <div className="flex flex-col w-full">
        {businessUnits.map((unit, index) => {
        const isEven = index % 2 === 0;
        return <div key={index} data-index={index} className={cn("flex flex-col w-full min-h-[600px]", isEven ? "lg:flex-row" : "lg:flex-row-reverse")}>
              {}
              <div className={cn("w-full lg:w-1/2 relative h-[400px] lg:h-auto overflow-hidden group", isVisible ? "opacity-100 translate-y-0 transition-all duration-1000 ease-out" : "opacity-0 translate-y-10")} style={{
            transitionDelay: `${index * 200}ms`
          }}>
                <div className="absolute inset-0 bg-primary/10 z-10 group-hover:bg-primary/5 transition-colors duration-500" />
                <img src={`${unit.image}?w=1200&q=75`} alt={unit.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" />
              </div>

              {}
              <div className={cn("w-full lg:w-1/2 flex flex-col justify-center px-6 py-16 lg:px-20 xl:px-32 relative z-20", isEven ? "bg-gradient-to-br from-blue-950/40 to-cyan-950/20 backdrop-blur-sm" : "bg-gradient-to-br from-slate-950/40 to-zinc-950/20 backdrop-blur-sm", isVisible ? "opacity-100 translate-x-0 transition-all duration-1000 ease-out" : isEven ? "opacity-0 translate-x-10" : "opacity-0 -translate-x-10")} style={{
            transitionDelay: `${index * 200 + 200}ms`
          }}>
                <h3 className="font-sans text-3xl md:text-5xl font-bold text-primary mb-6 leading-tight tracking-tight uppercase">
                  {unit.title}
                </h3>
                <p className="font-sans text-muted-foreground text-lg leading-relaxed mb-10 max-w-xl border-l-2 border-primary/30 pl-6">
                  {unit.description}
                </p>
                <div>
                  <Button asChild className="rounded-none border border-primary bg-transparent text-primary hover:bg-primary hover:text-primary-foreground px-10 py-7 text-base font-bold tracking-widest uppercase transition-all duration-300 group">
                    <Link to={unit.link}>
                      Learn More
                      <ArrowRight className="ml-3 h-5 w-5 transition-transform group-hover:translate-x-2" />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>;
      })}
      </div>
    </section>;
}